import type { KpiCascadeState } from '~/state/useKpiCascadeState'

/** Wave-6 §4 (D5): mirrors KpiCascade's render conditions EXACTLY — the KPI select always;
 *  a driver control (select OR fixed chip) when axisCount ≥ 2 with ≥1 option; a VT control
 *  when axisCount = 3 with ≥1 option. Chips count: they occupy the same width class.
 *  The parity test pins this against the real component. */
export function cascadeControlCount(state: KpiCascadeState): number {
  let n = 1
  if (state.axisCount >= 2 && state.driverOptions.length >= 1) n += 1
  if (state.axisCount === 3 && state.valueTypeOptions.length >= 1) n += 1
  return n
}
